import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChats = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.8942 27.8539C24.4715 27.4833 28.9142 22.9775 29.2798 17.3211C29.3513 16.2142 29.3513 15.0678 29.2798 13.9609C28.9142 8.30443 24.4715 3.79876 18.8942 3.42801C16.9914 3.30153 15.0049 3.3018 13.1059 3.42801C7.5286 3.79876 3.08596 8.30443 2.7204 13.9609C2.64886 15.0678 2.64886 16.2142 2.7204 17.3211C2.85354 19.3813 3.76465 21.2887 4.83729 22.8994C5.46009 24.027 5.04906 25.4343 4.40036 26.6637C3.93262 27.5501 3.69876 27.9933 3.88653 28.3134C4.07432 28.6335 4.49376 28.6438 5.33265 28.6642C6.99164 28.7046 8.11032 28.2342 8.99832 27.5794C9.50195 27.2081 9.75377 27.0223 9.92733 27.001C10.1009 26.9797 10.4424 27.1203 11.1254 27.4017C11.7393 27.6545 12.452 27.8105 13.1059 27.8539C15.0049 27.9802 16.9914 27.9805 18.8942 27.8539Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.9936 16H16.0056M21.3209 16H21.3329M10.6663 16H10.6782",
		stroke: "currentColor",
		strokeWidth: 2.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgChats;
